var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcImageDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39856_164381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 142,
    height: 142
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    rx: 8,
    fill: "#FFF8EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39856_164381)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    fill: "#E7E8EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39856_164381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6109 47.6665H57.3887C54.8112 47.6696 52.3401 48.6949 50.5175 50.5175C48.6949 52.3401 47.6696 54.8112 47.6665 57.3887V84.6109C47.6696 87.1885 48.6949 89.6596 50.5175 91.4822C52.3401 93.3048 54.8112 94.3301 57.3887 94.3332H84.6109C87.1885 94.3301 89.6596 93.3048 91.4822 91.4822C93.3048 89.6596 94.3301 87.1885 94.3332 84.6109V57.3887C94.3301 54.8112 93.3048 52.3401 91.4822 50.5175C89.6596 48.6949 87.1885 47.6696 84.6109 47.6665V47.6665ZM57.3887 51.5554H84.6109C86.158 51.5554 87.6418 52.17 88.7357 53.2639C89.8297 54.3579 90.4443 55.8416 90.4443 57.3887V84.6109C90.4409 85.4772 90.2415 86.3314 89.8609 87.1096L72.044 69.2926C71.1412 68.3895 70.0693 67.6732 68.8896 67.1844C67.7099 66.6957 66.4454 66.4441 65.1684 66.4441C63.8915 66.4441 62.627 66.6957 61.4473 67.1844C60.2676 67.6732 59.1957 68.3895 58.2929 69.2926L51.5554 76.0282V57.3887C51.5554 55.8416 52.17 54.3579 53.2639 53.2639C54.3579 52.17 55.8416 51.5554 57.3887 51.5554ZM57.3887 90.4443C55.8416 90.4443 54.3579 89.8297 53.2639 88.7357C52.17 87.6418 51.5554 86.158 51.5554 84.6109V81.5271L61.0404 72.0421C61.5821 71.5 62.2253 71.07 62.9333 70.7766C63.6413 70.4832 64.4001 70.3322 65.1665 70.3322C65.9329 70.3322 66.6917 70.4832 67.3997 70.7766C68.1077 71.07 68.7509 71.5 69.2926 72.0421L87.1096 89.8609C86.3314 90.2415 85.4772 90.4409 84.6109 90.4443H57.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7777 68.0833C80.1237 68.0833 81.4395 67.6841 82.5587 66.9363C83.6779 66.1885 84.5501 65.1257 85.0652 63.8821C85.5803 62.6385 85.7151 61.2702 85.4525 59.95C85.1899 58.6299 84.5418 57.4172 83.59 56.4655C82.6382 55.5137 81.4256 54.8655 80.1054 54.6029C78.7853 54.3403 77.4169 54.4751 76.1734 54.9902C74.9298 55.5053 73.8669 56.3776 73.1191 57.4968C72.3713 58.6159 71.9722 59.9317 71.9722 61.2777C71.9722 63.0827 72.6892 64.8137 73.9655 66.09C75.2418 67.3663 76.9728 68.0833 78.7777 68.0833ZM78.7777 58.3611C79.3546 58.3611 79.9185 58.5321 80.3981 58.8526C80.8778 59.1731 81.2516 59.6286 81.4724 60.1616C81.6931 60.6945 81.7509 61.281 81.6383 61.8467C81.5258 62.4125 81.248 62.9322 80.8401 63.3401C80.4322 63.748 79.9125 64.0258 79.3467 64.1384C78.781 64.2509 78.1945 64.1931 77.6616 63.9724C77.1286 63.7516 76.6731 63.3778 76.3526 62.8981C76.0321 62.4185 75.8611 61.8546 75.8611 61.2777C75.8611 60.5042 76.1683 59.7623 76.7153 59.2153C77.2623 58.6684 78.0042 58.3611 78.7777 58.3611Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39856_164381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.6667,
    height: 46.6667,
    fill: "white",
    transform: "translate(47.6665 47.6665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImageDefault);
export default __webpack_public_path__ + "static/media/ic_image_default.7dd4d9dda32d4ea79a440b16113a4da3.svg";
export { ForwardRef as ReactComponent };